import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch } from "vue"
import i18n from '@/lang/i18n';
import ConfirmationModal from "@/components/Common/ConfirmationModalBase.vue";

type Props = {
  modalState: boolean,
  title?: string,
  titleClass?: string,
  subTitle?: string,
  subTitleClass?: string,
  note?: string,
  noteClass?: string,
  confirmBtnName?: string | null,
  confirmBtnClass?: string,
  cancelBtnName?: string | null,
  cancelBtnClass?: string,
  btnClass?: string,
  modalMaxWidth?: string,
  loading?: boolean,
};

export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmationModal',
  props: {
    modalState: { type: Boolean, default: false },
    title: { default: i18n.global.t('common.confirmationModal.title') },
    titleClass: { default: 'confirmation-modal-title' },
    subTitle: {},
    subTitleClass: { default: 'confirmation-modal-subtitle' },
    note: {},
    noteClass: { default: 'confirmation-modal-note' },
    confirmBtnName: { default: i18n.global.t('common.confirmBtn') },
    confirmBtnClass: {},
    cancelBtnName: { default: i18n.global.t('common.cancelBtn') },
    cancelBtnClass: { default: 'reset-btn' },
    btnClass: {},
    modalMaxWidth: {},
    loading: { type: Boolean }
  },
  emits: ['confirm', 'cancel'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const localModalState = ref(false)

watch(() => props.modalState, (value) => {
  localModalState.value = value
})

const emits = __emit

function confirm() {
  emits("confirm");
}

function cancel() {
  emits("cancel");
  localModalState.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ConfirmationModal, {
    title: props.title,
    note: props.note,
    modalState: props.modalState,
    rightBtnName: props.cancelBtnName,
    rightBtnClass: props.cancelBtnClass,
    onRightBtnAction: cancel,
    leftBtnName: props.confirmBtnName,
    leftBtnClass: props.confirmBtnClass,
    onLeftBtnAction: confirm,
    leftLoading: props.loading
  }, null, 8, ["title", "note", "modalState", "rightBtnName", "rightBtnClass", "leftBtnName", "leftBtnClass", "leftLoading"]))
}
}

})